import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { Wizard } from "./wizards/wizard.component";
import { WizardComplete } from "./wizards/wizard-complete.component";

const routes: Routes = [
    { path: "mortgage", component: Wizard },
    { path: "remortgage", component: Wizard },
    { path: "book-mortgage-appointment", component: Wizard},
    { path: "complete", component: WizardComplete } 
];

@NgModule({
    imports: [RouterModule.forRoot(routes,
        {
            useHash:true,
            enableTracing:false
        })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
